'use client';

import * as React from 'react';
import { pathPrefixAtom } from 'app/blog/[domain]/_components/blog-state';
import { IconArrowLeft } from 'icon/Arrows/arrow-left';
import { useAtomValue } from 'jotai';
import { useTranslations } from 'next-intl';
import { useRouter } from 'next-nprogress-bar';
import { Button } from 'ui';

export function NotFoundButtons(): JSX.Element {
  const router = useRouter();
  const urlPrefix = useAtomValue(pathPrefixAtom);
  const t = useTranslations('Blog.NotFound');
  return (
    <>
      <Button
        onClick={() => {
          router.back();
        }}
        className="not-found-button not-found-button-back group"
        variant="outline"
      >
        <IconArrowLeft className="size-6 transition group-hover:-translate-x-1" />
        {t('GoBack')}
      </Button>
      <Button
        className="not-found-button not-found-button-home"
        onClick={async () => {
          router.push(`${urlPrefix}/`);
        }}
      >
        {t('GoHome')}
      </Button>
    </>
  );
}
